export default __webpack_public_path__ + "static/media/mural-rotated.c15a0be3.jpeg";